import DiscoverSideNav from './DiscoverSideNav.component';
export default DiscoverSideNav;